// Custom Components
import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import ButtonPrimary from "../../components/buttonPrimary";
import StatusCard from "../../components/statusCard";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { setTimer, setStartTime, resetAll } from "../../store/ingredient";
import { get } from "lodash";
import buttonSound from "../../assets/sound/button.mp3";

// Styles
import "./styles.scss";
import { GC } from "../../services/config/gamecentreService";
import { storage } from "../../services/config/storage";
import { sendStats } from "../../services/network";
import { useState } from "react";

function Score(props) {
  const dispatch = useDispatch();
  const startTime = useSelector((state) => get(state, "ingredients.startTime"));
  const endTime = useSelector((state) => get(state, "ingredients.endTime"));
  const moves = useSelector((state) => get(state, "ingredients.moves"));
  const served = useSelector((state) => get(state, "ingredients.served"));
  const correctServed = useSelector((state) =>
    get(state, "ingredients.correctServed")
  );
  const points = useSelector((state) => get(state, "ingredients.points"));
  const burntPatty = useSelector((state) =>
    get(state, "ingredients.burntPatty")
  );
  const totalIngredientsPlaced = useSelector((state) =>
    get(state, "ingredients.totalIngredientsPlaced")
  );
  const correctIngredientsPlaced = useSelector((state) =>
    get(state, "ingredients.correctIngredientsPlaced")
  );
  const pattiesPlaced = useSelector((state) =>
    get(state, "ingredients.pattiesPlaced")
  );
  const bunsPlaced = useSelector((state) =>
    get(state, "ingredients.bunsPlaced")
  );
  const pattiesTrashed = useSelector((state) =>
    get(state, "ingredients.pattiesTrashed")
  );

  const getTimeDiffrence = (type) => {
    var __startTime = moment(startTime).format();
    var __endTime = moment(endTime).format();

    var __duration = moment.duration(moment(__endTime).diff(__startTime));
    if (type == "s") return __duration.asSeconds();
    return `${__duration.minutes()}:${__duration.seconds()}`;
  };

  const [sendingData, setSendingData] = useState(false);
  const [dataNotSentCount, setDataNotSentCount] = useState(3);

  useEffect(() => {
    sendStatsTrigger()
  }, [])

  const sendStatsTrigger = () => {
    sendStats({
      level: 1,
      totalTime: getTimeDiffrence("s"),
      totalServed: served,
      incorrectServed: served - correctServed,
      correctServed: correctServed,
      isLevelCleared: false,
      totalAccuracy: correctServed / served,
      totalLevelCleared: 0,
      totalAverageMoveTime: Number(getTimeDiffrence("s")) / served,
      firstMoveTime: 0,
      extraLevelData: {
        burntPatty: burntPatty,
        points: points,
        totalMoves: moves,
        totalIngredientsPlaced: totalIngredientsPlaced,
        correctIngredientsPlaced: correctIngredientsPlaced,
        incorrectIngredientsPlaced:
          totalIngredientsPlaced - correctIngredientsPlaced,
        pattiesPlaced: pattiesPlaced,
        bunsPlaced: bunsPlaced,
        pattiesTrashed: pattiesTrashed,
      },
    });
    dispatch(resetAll());
  };

  const endGame = () => {
    GC.sendGameEndMessage();
    storage.destroy.all();
  }

  return (
    <section className="score-page-style bg-primary">
      <div className="feedback-section">
        <StatusCard points={points} moves={served} title="You did great!" />

        {/* <h4 className="title">You did better than 95% players</h4> */}
        <ButtonPrimary
          disabled={sendingData}
          buttonText="Continue"
          onClickHandler={() => {
            // dispatch(resetAll());
            // dispatch(setTimer(Date.now() + 300000));
            // dispatch(setStartTime(moment()));
            // props.history.push("/main");
            const buttonSound = document.getElementById("buttonSound");
            buttonSound.play();
            endGame();
          }}
        />
      </div>

      <audio controls id="buttonSound" className="audio-hide">
        <source src={buttonSound} type="audio/mp3" />
      </audio>
    </section>
  );
}

export default withRouter(Score);
